/**
Project: Voice Panel (c)
Title: Voice Admin Constants
Description: Constants of the Voice Admin Panel
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import microsoftTeamsImage from "../../../../../assets/images/platform-image/teams.png";
import zoomImage from "../../../../../assets/images/platform-image/zoom.png";
import oCTeamsImage from "../../../../../assets/images/platform-image/octeams.png";
import otherImage from "../../../../../assets/images/platform-image/other.png";

export const VoiceAdminConstants = {
  APP_NAME: "Voice Panel",
  USER_ROLE: {
    GLOBAL_ADMIN: "Global Administrator",
    TEAMS_ADMIN: "Teams Administrator",
  },
  CONSENT_LINK: `https://login.microsoftonline.com/common/adminconsent?client_id=${
    process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_ID
  }&redirect_uri=${window.origin + "/signin"}`,
  COMMON: {
    YES: "Yes",
    NO: "No",
  },
  COMMUNICATION_PLATFORMS: {
    MICROSOFT_TEAMS: "Microsoft Teams",
  },
  GENERAL: {
    CONSENT_STATUS:{
      ACCEPTED:"Accepted",
      NOT_ACCEPTED:"NotAccepted",
      WITHDRAWN:"Withdrawn"
    },
    COMMUNICATION_PLATFORM_DATA: [
      {
        platformName: "Microsoft Teams",
        platformIcon: microsoftTeamsImage,
        platformType: "E",
        platformLink: "https://admin.teams.microsoft.com/",
        platformStatus: "Active",
      },
      {
        platformName: "Zoom",
        platformIcon: zoomImage,
        platformType: "E",
        platformLink: "https://zoom.us/",
        platformStatus: "Active",
      },
      {
        platformName: "OC Teams",
        platformIcon: oCTeamsImage,
        platformType: "E",
        platformLink: "https://admin.teams.microsoft.com/",
        platformStatus: "Active",
      },
      {
        platformName: "Other",
        platformIcon: otherImage,
        platformLink: null,
        platformStatus: "Active",
        platformType: "O",
      },
    ],
    PLATFORM_STATUS: {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
    },
  },
  VOICE_SETUP: {
    PROGRESS: {
      WELCOME: 0,
      // ACCOUNT: 1,
      PRESENCE: 2,
      SETUP: 3,
      // ROUTING: 4,
      // USERS: 5,
      SUMMARY: 6,
    },

    SETUP_STATUS: {
      NOT_STARTED: 0,
      IN_PROGRESS: 1,
      SUCCESS: 2,
      FAILURE: 3,
    },
    SIPPIO_SUPPORT_EMAIL: "support@Sippio.io",
    RERUN_SETUP_PRIVILEGE_USERS: [
      "adam@telagility.biz",
      "admin@sippiodemo.io",
      "mrtest@sippiotest.com",
      "test101sh@sippiotest.com",
    ],
  },
  NUMBERS_PRIVILEGE_USERS: ["TAC40002-", "SIM60017-"],
  INVENTORY: {
     CLASSIFICATION_TYPE:{
      STORE:"Store",
      E_FAX:"eFax"
    },
    NUMBER_FILE_MAXIMUM_ROWS: 3000,
    ADD_DEVICE_STATUS: {
      YES: "Yes",
      NO: "No",
    },
    MANAGE_STATUS: {
      UNMANAGED: "Unmanaged",
      MANAGED: "Managed",
    },
    ASSIGN_STATUS: {
      ASSIGNED: "Assigned",
      UNASSIGNED: "Unassigned",
    },
    RESERVED_STATUS: {
      RESERVED: "Reserved",
      UNRESERVED: "Unreserved",
    },
    IMPORT: ["Numbers", "Devices"],
    FILE_TYPES: [".csv"],
    NUMBER_COLUMNS: [
      "CountryName",
      "PhoneNumber",
      "UserName",
      "StreetAddress1",
      "StreetAddress2",
      "City",
      "State",
      "Country",
      "PostalCode",
      "Carrier",
      "NumberType",
      "Department",
      "Managed_Unmanaged",
      "Classification",
      "Assigned_Unassigned",
      "Reserved_Unreserved",
      "Notes",
    ],
    NUMBER_JSON_KEYS: [
      "numberCountryName",
      "phoneNumber",
      "userName",
      "streetAddress1",
      "streetAddress2",
      "city",
      "state",
      "country",
      "postalCode",
      "carrierName",
      "numberTypeName",
      "departmentName",
      "manageStatus",
      "classification",
      "assignStatus",
      "reserveStatus",
      "numberNotes",
    ],
    DEVICE_COLUMNS: [
      "CountryName",
      "PhoneNumber",
      "DeviceType",
      "Make",
      "Model",
      "SerialNumber",
    ],
    DEVICE_JSON_KEYS: [
      "numberCountryName",
      "phoneNumber",
      "deviceTypeName",
      "makeName",
      "modelName",
      "serialNumber",
    ],
    DATA_PROPAGATION: {
      OVERALL_STATUS_NOTSTARTED: "NotStarted",
      OVERALL_STATUS_INPROGRESS: "InProgress",
      OVERALL_STATUS_COMPLETED: "Completed",
      ITEM_PROCESS_STATUS_NOTSTARTED: "NotStarted",
      ITEM_PROCESS_STATUS_INPROGRESS: "InProgress",
      ITEM_PROCESS_STATUS_COMPLETED: "Completed",
      ITEM_UPDATE_STATUS_SUCCESS: "Success",
      ITEM_UPDATE_STATUS_FAILURE: "Failure",
      ITEM_PROPAGATION_STATUS_NOTSTARTED: "NotStarted",
      ITEM_PROPAGATION_STATUS_INPROGRESS: "InProgress",
      ITEM_PROPAGATION_STATUS_COMPLETED: "Completed",
    },
    CARRIERLOCK: {
      YES: "Yes",
      NO: "No",
    },
  },
  USERS: {
    ASSIGN_STATUS: {
      ALL: "All",
      ASSIGNED: "Assigned",
      UNASSIGNED: "Unassigned",
    },
    PHONE_ASSIGN_STATUS:[
      {
        name: 'yes',
        key: 'Yes',
        label: 'Yes',
        value: 'Yes',
      },
      {
        name: 'no',
        key: 'No',
        label: 'No',
        value: 'No',
      }
    ],
    RESERVED_STATUS: {
      RESERVED: "Reserved",
      UNRESERVED: "Unreserved",
    },
    FILTER_CONDITIONS: {
      ALL_CONDITIONS: "All",
      ANY_CONDITIONS: "Any",
    },
    USER_COLUMNS: ["UserName", "PhoneNumber", "CallingPolicy"],
    USER_JSON_KEYS: ["email", "phone", "policyId"],
    FILE_TYPES: [".csv"],
    NUMBER_OF_USER_LESS_THAN_ONE_HUNDRED: 100,
    NUMBER_OF_USER_LESS_THAN_FIFTY: 50,
    PAGE_SIZE: "100",
    BUlk_DATA: "Data",
    BULK_STATUS: "Status",
  },
  BUY_NUMBERS: {
    PEERLESS: "PEERLESS",
    PROVISION: "Provision",
    STATE: "State",
    LATA: "LATA",
    NPA_NXX: "NPA-NXX",
    USA: "United States",
    UNITED_STATES: "UNITED STATES",
    CANADA: "Canada",
    TIME_SUBTRACTION: 5,
    NUMBER_TYPES: {
      LOCAL: "Local",
      TOLL_FREE: "Tollfree",
    },
    CATEGORY: {
      STANDARD: "Standard",
      VANITY: "Vanity",
    },
    EXTRACT_TYPE: {
      SIPPIO: "SIPPIO",
    },
    NUMBERS_ORDER_PEERLESS_LOCK_DURATION: 25, // 25 minutes
    INPUT_PREVENT_CHARACTERS_KEY: ["e", "E", ".", "+", "-"],
    INPUT_PREVENT_CHARACTERS_KEY_CODE: [69, 190, 187, 189],
  },
  DOMAIN_SETUP: {
    PROGRESS: {
      WELCOME: 0,
      ACCOUNT: 1,
      REGION: 2,
      DOMAINS: 3,
      USERS: 4,
      SUMMARY: 5,
    },
    SETUP_STATUS: {
      NOT_STARTED: 0,
      IN_PROGRESS: 1,
      SUCCESS: 2,
      FAILURE: 3,
    },
    PROCESS_STATUS: {
      NOT_STARTED: "Not Started",
      IN_PROGRESS: "In Progress",
      SUCCESS: "Success",
      FAILURE: "Failure",
      REGIONS: "Regions",
      RECORDS: "Records",
      USERS: "Users",
      COMPLETED: "Completed",
    },
    SIPPIO_SUPPORT_EMAIL: "support@Sippio.io",
  },

  VOICE_ROUTES_MAP: {
    STATUS: {
      PRIMARY: "PRIMARY",
      FAILOVER: "FAILOVER",
      UNASSIGNED: "UNASSIGNED",
    },
    COLOR: {
      MARKER_PRIMARY: "#10C309CC",
      MARKER_FAILOVER: "#10C309CC",
      MARKER_UNASSIGNED: "#7A7A7ACC",
    },
  },

  TABLE_DATA: {
    SORT_ORDER: {
      ASCENDING: "ASC",
      DESCENDING: "DESC",
    },
    PAGE_LIMIT_DEFAULT: 50,
    PAGE_OFFSET_DEFAULT: 0,
    PAGE_LIMIT_OPTIONS: [10, 25, 50, 100],
  },

  USN_DATA_PROPAGATION: {
    OVERALL_STATUS_NOTSTARTED: "NotStarted",
    OVERALL_STATUS_INPROGRESS: "InProgress",
    OVERALL_STATUS_COMPLETED: "Completed",
    ITEM_PROCESS_STATUS_NOTSTARTED: "NotStarted",
    ITEM_PROCESS_STATUS_INPROGRESS: "InProgress",
    ITEM_PROCESS_STATUS_COMPLETED: "Completed",
    ITEM_UPDATE_STATUS_SUCCESS: "Success",
    ITEM_UPDATE_STATUS_FAILURE: "Failure",
    ITEM_PROPAGATION_STATUS_NOTSTARTED: "NotStarted",
    ITEM_PROPAGATION_STATUS_INPROGRESS: "InProgress",
    ITEM_PROPAGATION_STATUS_COMPLETED: "Completed",
  },

  SERVER_ERROR_CODE: {
    DOMAIN_CREATE_FAILED: "E11012",
    // voice setup
    PSTN_USAGE_CREATE_FAILED: "E11005",
    VOICE_ROUTES_CREATE_FAILED: "E11006",
    VOICE_SETUP_NOTCOMPLETED: "E11021",
    // Routing
    ROUTING_POLICY_CREATE_FAILED: "E11007",
    ROUTING_POLICY_ENABLE_FAILED: "E11023",
    ROUTING_POLICY_DISABLE_FAILED: "E11024",
    VOICE_ROUTES_UPDATE_FAILED: "E11022",
    // users
    USERS_DATA_UPDATE_FAILED: "E12011",
    USERS_IMPORT_FILE_INVALID: "E12005",
    USERS_IMPORT_FILE_NOCHANGES: "E12006",
    USERS_CANNOT_CONTAIN_MORE_THAN_FIVE_HUNDRED_RECORD: "E12009",
    USERS_QUERY_PERAMETER_MISSING_OR_INVALID: "E12011",
    USERS_MICROSOFT_TENANT: "E12016",
    USERS_DATA_UPDATE_ALREADY_INPROGRESS: "E12021",
    // service numbers
    SERVICE_NUMBERS_MICROSOFT_TENANT: "E13016",
    SERVICE_NUMBERS_UPDATE_ALREADY_INPROGRESS: "E13021",
    // Domain setup
    REGIONS_CREATE_FAILED: "E14011",
    DOMAINS_CREATE_FAILED: "E14012",
    UNABLE_TO_CHECK_USERS: "E14013",
    // Buy numbers
    US_ATL_API_FAILED: "E16033",
    ONE_BILL_SAVE_FAILED: "E10121",
    DB_SAVE_FAILED: "E10122",
    ADDRESS_1_REQUIRED: "E16017",
    ADDRESS_CITY_REQUIRED: "E16018",
    ADDRESS_STATE_REQUIRED: "E16019",
    ADDRESS_ZIPCODE_REQUIRED: "E16020",
    BUSINESS_NAME_REQUIED: "E16016",
    EMAIL_MISSING_OR_INVALID: "E16012",
    EMAIL_REQUEST_FAILED: "E16031",
    COUNTRY_NAME_MISSING_OR_INVALID: "E16002",
    COUNTRY_CODE_MISSING_OR_INVALID: "E16003",
    CATEGORY_MISSING_OR_INVALID: "E16022",
    CUSTOMER_NAME_REQUIRED: "E16013",
    CONSECUTIVE_QUANTITY_MISSING_OR_INVALID: "E16008",
    SEARCH_TYPE_MISSING_OR_INVALID: "E16010",
    SEARCH_EXPRESSION_REQUIRED: "E16011",
    SEARCH_TYPE_FAILED: "E16021",
    NUMBER_TYPE_MISSING_OR_INVALID: "E16004",
    PHONE_NUMBERS_REQUIRED: "E16015",
    PEELESS_API_FAILED: "E16032",
    PROVISION_API_FAILED: "E16034",
    PROVISION_PROACATIVE_API_FAILED: "E16035",
    QUANTITY_MISSING_OR_INVALID: "E16006",
    // Departement
    ADD_DEPARTMENT_FAILED: "E15121",
    UPDATE_DEPARTMENT_FAILED: "E15122",
    DELETE_DEPARTMENT_INUSED_FAILED: "E15113",
    UNABLE_DELETE_DEPARTMENT_FAILED: "E15123",
    DEPARTMENT_NAME_ALREADY_EXISTS: "E15103",
    DEPARTMENT_NAME_REQUIRED: "E15102",
    // Number Type
    ADD_NUMBERTYPE_FAILED: "E15221",
    UPDATE_NUMBERTYPE_FAILED: "E15222",
    NUMBERTYPE_NAME_ALREADY_EXISTS: "E15203",
    NUMBERTYPE_NAME_REQUIRED: "E15202",
    DELETE_NUMBERTYPE_INUSED_FAILED: "E20213",
    UNABLE_DELETE_NUMBERTYPE_FAILED: "E20223",
    // Device Type
    ADD_DEVICETYPE_FAILED: "E15421",
    UPDATE_DEVICETYPE_FAILED: "E15422",
    DEVICETYPE_NAME_ALREADY_EXISTS: "E15403",
    DEVICETYPE_ID_REQUIRED: "E15401",
    DEVICETYPE_ID_UNMATCHED: "E15420",
    DEVICETYPE_NAME_REQUIRED: "E15402",
    DEVICETYPE_SERIAL_NUMBER_REQUIRED: "E15404",
    DEVICETYPE_SERIAL_NUMBER_NOT_VALID: "E15405",
    // Carrier
    ADD_CARRIER_FAILED: "E15321",
    UPDATE_CARRIER_FAILED: "E15322",
    CARRIER_NAME_ALREADY_EXISTS: "E15303",
    CARRIER_NAME_REQUIRED: "E15302",
    DELETE_CARRIER_INUSED_FAILED: "E20313",
    UNABLE_DELETE_CARRIER_FAILED: "E20323",
    // Number Inventory
    PHONE_NUMBER_REQUIRED: "E17002",
    MANAGE_STATUS_REQUIRED: "E17021",
    ASSIGN_STATUS_REQUIRED: "E17021",
    RESERVE_STATUS_REQUIRED: "E17021",
    NUMBER_COUNTRY_NAME_REQUIRED: "E17007",
    PHONE_NUMBER_ALREADY_EXISTS: "E17004",
    NUMBER_DATA_UPDATE_FAILED: "E17035",
    ADD_NUMBER_FAILED: "E17051",
    UPDATE_NUMBER_FAILED: "E17052",
    NUMBER_DATA_NOT_FOUND: "E17050",
    NUMBER_IMPORT_FAILED: "E17053",
    NUMBER_WRONG_FILE_IMPORT: "E17031",
    NUMBER_IMPORT_NO_UPDATES: "E17032",
    NUMBER_SYNC_ALREADY_INPROGRESS: "E12031",
    NUMBER_CANNOT_CONTAIN_MORE_THAN_THREE_THOUSAND_RECORD: "E17034",
    NUMBER_IMPORT_INVALID_HEADERS: "E17033",
    DEPARTMENT_INVALID: "E17011",
    CARRIER_INVALID: "E17013",
    NUMBERTYPE_INVALID: "E17012",
    DEVICE_TYPE_NAME: "E17014",
    DEVICE_ADD_FAILED: "E17062",
    DEVICE_TYPE_REQUIRED: "E17019",
    DEVICE_NUMBER_REQUIED: "E17001",
    DEVICE_UPDATE_FAILED: "E17063",
  },
};
